import {useCallback, useEffect, useLayoutEffect, useRef, useState} from "react";
export function useStateWithCallback(initialState, callback) {
  const [state, setState] = useState(initialState);
  useEffect(() => callback(state), [state, callback]);
  return [state, setState];
}
export function useStateWithCallbackInstant(initialState, callback) {
  const [state, setState] = useState(initialState);
  useLayoutEffect(() => callback(state), [state, callback]);
  return [state, setState];
}
export function useStateWithCallbackLazy(initialValue) {
  const callbackRef = useRef(null);
  const [state, setState] = useState(initialValue);
  useEffect(() => {
    if (callbackRef.current) {
      callbackRef.current(state);
      callbackRef.current = null;
    }
  }, [state]);
  const setStateWithCallback = useCallback((value, callback) => {
    if (callback) {
      callbackRef.current = callback;
    }
    return setState(value);
  }, []);
  return [state, setStateWithCallback];
}
